import { isApp } from "../../utils/meng";

const activityModule = {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    // 许可
    // permission({ state, getters, commit, dispatch }) {
    //   return new Promise((resolve, reject) => {
    //     // 如果不是在APP打开
    //     if (!isApp()) {
    //       return;
    //     }
    //     resolve();
    //   });
    // },
    // fetchShops({ commit, state }, params) {}
  }
};

export default activityModule;
